var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImprovement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.958 5.019 3.832 2.84v.923c0 .083.033.16.089.219l.84.55 2.855-2.856-.565-.821a.307.307 0 0 0-.218-.093h-.923L5.033 1.96a2.208 2.208 0 0 0-3.379-.313 2.196 2.196 0 0 0-.636 1.762 2.2 2.2 0 0 0 .94 1.61zM15.61 13.559a.312.312 0 0 0-.17-.145l-1.143-.38-3.01-2.917-1.143 1.143 2.908 3.018.38 1.144c.025.07.078.132.145.17L16 16.937a.302.302 0 0 0 .366-.05l.541-.537a.312.312 0 0 0 .05-.37L15.61 13.56z",
    fill: "#A22FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.584 9.333 2.3-2.3c.326.11.667.169 1.018.169a3.1 3.1 0 0 0 2.927-4.114.31.31 0 0 0-.51-.114L14.961 4.33a.934.934 0 0 1-1.294 0 .917.917 0 0 1 0-1.294l1.359-1.356a.312.312 0 0 0-.117-.51A3.15 3.15 0 0 0 13.895 1c-.827 0-1.608.323-2.192.907a3.09 3.09 0 0 0-.738 3.21L9.61 6.473 6.48 9.6l-1.356 1.356a3.155 3.155 0 0 0-1.018-.169 3.1 3.1 0 0 0-2.927 4.114.31.31 0 0 0 .221.197.299.299 0 0 0 .286-.083l1.36-1.356a.934.934 0 0 1 1.294 0 .917.917 0 0 1 0 1.294l-1.36 1.357a.312.312 0 0 0 .118.51c.326.11.667.169 1.014.169.828 0 1.609-.323 2.193-.907a3.09 3.09 0 0 0 .738-3.21l2.3-2.297 1.242-1.242z",
    fill: "#A22FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprovement);
export default __webpack_public_path__ + "static/media/improvement.6ad0b79a46fd09d74431dc8d9b834f68.svg";
export { ForwardRef as ReactComponent };